// extracted by mini-css-extract-plugin
export var actionButton = "_ks-0";
export var fileInput = "_ks-2";
export var paperclip = "_ks-1";